import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a479eb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = {
  class: "supplies-drawer",
  "aria-label": "酒吧物品与玩家背包"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "BAR SUPPLIES"),
  /*#__PURE__*/_createElementVNode("h2", null, "物品与行囊")
], -1))
const _hoisted_4 = { class: "head-actions" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "supply-tabs" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 酒吧库存 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 我的背包 ")
const _hoisted_9 = {
  key: 0,
  class: "drawer-message error"
}
const _hoisted_10 = {
  key: 1,
  class: "drawer-message notice"
}
const _hoisted_11 = {
  key: 2,
  class: "drawer-loading"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "supply-list"
}
const _hoisted_17 = { class: "item-code" }
const _hoisted_18 = { class: "item-copy" }
const _hoisted_19 = { class: "item-title" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "submit-row"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上交给酒吧", -1))
const _hoisted_24 = ["onUpdate:modelValue", "max", "placeholder"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = {
  key: 4,
  class: "empty-supplies"
}

import { computed, reactive, ref } from 'vue'
import type { BackpackItem, IngredientCatalogItem } from './types'


export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    loading: { type: Boolean },
    ingredients: null,
    backpack: null,
    error: null,
    notice: null,
    submittingType: null
  },
  emits: ["close", "refresh", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void
  (event: 'refresh'): void
  (event: 'submit', item: BackpackItem, quantity: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  open: boolean
  loading: boolean
  ingredients: IngredientCatalogItem[]
  backpack: BackpackItem[]
  error: string
  notice: string
  submittingType: number
}





const tab = ref<'bar' | 'backpack'>('bar')
const submitAmounts = reactive<Record<number, number>>({})
const currentItems = computed(() => tab.value === 'bar' ? props.ingredients : props.backpack)
const catalogByType = computed(() => new Map(props.ingredients.map(item => [item.type_id, item])))

function catalog(item: IngredientCatalogItem | BackpackItem) {
  return catalogByType.value.get(item.type_id)
}

function availableQty(item: IngredientCatalogItem | BackpackItem, source: 'bar' | 'backpack') {
  return source === 'bar' ? (item as IngredientCatalogItem).available_qty : (item as BackpackItem).quantity
}

function asBackpackItem(item: IngredientCatalogItem | BackpackItem) {
  return item as BackpackItem
}

function defaultSubmit(item: IngredientCatalogItem | BackpackItem) {
  const backpackItem = asBackpackItem(item)
  if (!submitAmounts[item.type_id]) submitAmounts[item.type_id] = Math.min(1, backpackItem.quantity)
  return submitAmounts[item.type_id]
}

function submit(item: IngredientCatalogItem | BackpackItem) {
  emit('submit', asBackpackItem(item), submitAmounts[item.type_id] || defaultSubmit(item))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["supplies-layer", { open: __props.open }]),
    "aria-hidden": !__props.open
  }, [
    _createElementVNode("button", {
      class: "supplies-backdrop",
      type: "button",
      "aria-label": "关闭物品抽屉",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("header", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            disabled: __props.loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('refresh')))
          }, "↻", 8, _hoisted_5),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
          }, "×")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ active: tab.value === 'bar' }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (tab.value = 'bar'))
        }, [
          _hoisted_7,
          _createElementVNode("b", null, _toDisplayString(__props.ingredients.length), 1)
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass({ active: tab.value === 'backpack' }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (tab.value = 'backpack'))
        }, [
          _hoisted_8,
          _createElementVNode("b", null, _toDisplayString(__props.backpack.length), 1)
        ], 2)
      ]),
      (__props.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.error), 1))
        : _createCommentVNode("", true),
      (__props.notice)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.notice), 1))
        : _createCommentVNode("", true),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
        : (_unref(currentItems).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentItems), (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: `${tab.value}-${item.type_id}`,
                  class: "supply-card"
                }, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.code), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                      _createElementVNode("span", null, _toDisplayString(availableQty(item, tab.value)) + " " + _toDisplayString(item.unit), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(item.codex || '岛上的普通物品。'), 1),
                    (tab.value === 'backpack')
                      ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(asBackpackItem(item).batch_count) + " 个批次 · 最早 " + _toDisplayString(new Date(asBackpackItem(item).earliest_expire_at * 1000).toLocaleDateString()) + " 到期", 1))
                      : (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(catalog(item)?.extra_enabled ? catalog(item)?.available ? '可加入鸡尾酒' : '当前库存不足' : '仅展示库存'), 1))
                  ]),
                  (tab.value === 'backpack')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((_unref(submitAmounts)[item.type_id]) = $event),
                          type: "number",
                          min: "0.01",
                          max: availableQty(item, 'backpack'),
                          step: "0.01",
                          placeholder: String(defaultSubmit(item))
                        }, null, 8, _hoisted_24), [
                          [
                            _vModelText,
                            _unref(submitAmounts)[item.type_id],
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: __props.submittingType === item.type_id,
                          onClick: ($event: any) => (submit(item))
                        }, _toDisplayString(__props.submittingType === item.type_id ? '上交中' : `上交 ${item.unit}`), 9, _hoisted_25)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("strong", null, _toDisplayString(tab.value === 'backpack' ? '行囊还是空的' : '今晚没有库存记录'), 1),
              _createElementVNode("p", null, _toDisplayString(tab.value === 'backpack' ? '可以先出门搜集一些东西。' : '稍后再来看看。'), 1)
            ]))
    ])
  ], 10, _hoisted_1))
}
}

})